var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56.1,77.1H36v27.5l-20.3,20.3c-2,2-2,5.3,0,7.3s5.3,2,7.3,0l21.8-21.8c1-1,1.5-2.3,1.5-3.6V81.8l18,18v28.7 c0,2.8,2.3,5.1,5.1,5.1c2.8,0,5.1-2.3,5.1-5.1V97.7c0-1.4-0.6-2.7-1.5-3.6L56.1,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,59.1l12.3-12.3c2.5,0.3,5.1-0.5,6.9-2.4c3.3-3.3,3.3-8.6,0-11.8c-3.3-3.3-8.6-3.3-11.8,0c-1.9,1.9-2.7,4.4-2.4,6.9 l-5,5v-4.7c0-2.5-1-4.7-2.6-6.4c-1.6-1.6-3.9-2.6-6.4-2.6c-2.5,0-4.7,1-6.4,2.6C37,35.1,36,37.4,36,39.9V72h18V59.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.3,
    cy: 19.3,
    rx: 9,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6,32.7c-3.3-3.3-8.6-3.3-11.8,0c-1.9,1.9-2.7,4.5-2.4,6.9l-9.9,9.9c-0.9,0.9-1.5,2.2-1.5,3.6c0,1.4,0.6,2.7,1.5,3.6 c0.9,0.9,2.2,1.5,3.6,1.5c1.4,0,2.7-0.6,3.6-1.5l9.9-9.9c2.5,0.3,5-0.5,6.9-2.4C100.9,41.2,100.9,35.9,97.6,32.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxing);
export default __webpack_public_path__ + "static/media/boxing.2206df285015c45af47791a8af6f22ea.svg";
export { ForwardRef as ReactComponent };